import { CustomBox } from "components/Box/CustomBox"
import React from "react"
import RegularButton from "components/CustomButtons/Button"
import AvTimerIcon from "@material-ui/icons/AvTimer"
import { fontSize, iconStyle } from "../CustomerView"
import { useSelector } from "react-redux"
import { cycleSelector } from "./selectorCycles"
import { useHandleView } from "../useHandleView"

export const CustomerCycles = () => {
  const cycles = useSelector(cycleSelector) || []
  const selectView = useHandleView(4)

  return (
    <CustomBox
      title="Ciclos Programados"
      count={cycles.length}
      icon={<AvTimerIcon style={iconStyle} />}
      bg={<AvTimerIcon style={{ ...iconStyle, fontSize }} />}
    >

      <RegularButton
        size="sm"
        color="info"
        fullWidth
        onClick={selectView}
      >
        Ver
      </RegularButton>
    </CustomBox>
  )
}